import { cn } from "@newxsystems/shared";
import { DaylightAction } from "../DaylightAction/DaylightAction";
import { DaylightMedia } from "../DaylightMedia/DaylightMedia";
import { DaylightRichText } from "../DaylightRichText/DaylightRichText";
import type { ICallToActionSplitProps } from "./CallToActionSplit.props";

const widths = { small: "w-2/3", medium: "w-5/6", large: "w-full" } as const;

export const CallToActionSplit = ({
  buttons,
  description,
  eyebrow,
  heading,
  image,
  imageWidth,
}: ICallToActionSplitProps) => (
  <div className="relative z-10 grid grid-cols-1 items-end gap-7 md:grid-cols-2 md:gap-14">
    {eyebrow ? (
      <p className="order-1 flex items-center gap-3 font-daylight-body text-sm font-semibold before:h-px before:w-8 before:bg-current md:col-start-1">
        {eyebrow}
      </p>
    ) : null}
    {image ? (
      <DaylightMedia
        aspectRatio={image.aspectRatio || "16:9"}
        className={cn(
          "order-2 w-full justify-self-end border-[10px] border-daylight/20 md:col-start-2 md:row-span-4 md:row-start-1 md:-rotate-1",
          widths[imageWidth || "medium"],
        )}
        media={image.image}
        sizes="(min-width: 768px) 50vw, 100vw"
      />
    ) : null}
    {heading ? (
      <h2 className="order-3 max-w-[12ch] break-words font-daylight-display text-[clamp(2.25rem,5.5vw,3.75rem)] font-semibold leading-[0.98] tracking-[-0.035em] md:col-start-1">
        {heading}
      </h2>
    ) : null}
    {description ? (
      <DaylightRichText
        className="order-4 max-w-[65ch] text-mineral-gray md:col-start-1"
        content={description}
      />
    ) : null}
    {buttons?.length ? (
      <div
        className={cn(
          "order-5 flex flex-wrap gap-3",
          image
            ? "md:col-start-1"
            : "md:col-start-2 md:row-span-3 md:row-start-1 md:justify-self-end",
        )}
      >
        {buttons.map((button, index) => (
          <DaylightAction
            action={button}
            className="border-mineral-gray text-mineral-gray"
            key={`${button.href}-${index}`}
          />
        ))}
      </div>
    ) : null}
  </div>
);

CallToActionSplit.displayName = "Content::CallToActionSplit";
